import commonStyles from 'Groups/stylesParams';

export default { ...commonStyles };
